import styled from "styled-components";

export const StyledTodoCard = styled.button`
    cursor: pointer;
    background: var(--color-white);
    border-radius: var(--radius-5);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
    display: flex;
    height: 50px;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    border: none;

    &:focus {
        background-color: var(--color-grey-400);
    }
`;
